import React from 'react';

import Confirm from 'components/Confirm';
import Message from 'components/Message';
import { deleteConfirmationMessages as messages } from './DisabledTimeWindows.messages';

const DeleteDisabledTimeWindowConfirm = () => (
  <Confirm
    title={<Message message={messages.title} />}
    acceptNode={<Message message={messages.accept} />}
    cancelNode={<Message message={messages.cancel} />}>
    <Message message={messages.body} />
  </Confirm>
);

export default DeleteDisabledTimeWindowConfirm;
